import { routeTree } from "@/routes";
import { createRouter } from "@tanstack/react-router";

export const router = createRouter({
	routeTree,
	defaultPreload: "intent",
});

let appNavCount = 0;
router.subscribe("onResolved", () => {
	appNavCount++;
});
export const hasAppHistory = () => appNavCount > 1;

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}
